var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"my-5"},[_c('h1',{staticClass:"font-weight-regular"},[_vm._v("Users")]),_c('v-row',[_c('v-col',{staticClass:"my-4"},[_c('UserList',{attrs:{"users":_vm.users}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }